module.exports = __webpack_public_path__ + "img/c3a6ce99c8070c6f45d5f0f5f49c4c63.svg";